import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Clock, RefreshCw } from 'lucide-react';
import { qrGet, qrPost, fmtDate } from './qrApi';
import { Button } from '@/components/ui/button';

/** Admin dashboard: devices flagged for clock drift with one-tap recompute / clear. */
export function ClockDriftCard() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => qrGet('/clock-drift/flagged').then(setRows).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const recompute = async (d) => { try { const r = await qrPost(`/devices/${d.device_id}/recompute-legs`); toast.success(`Recomputed ${r.recomputed} legs for ${d.trk_id}`); } catch (e) { toast.error(e.message); } };
  const clear = async (d) => { try { await qrPost(`/devices/${d.device_id}/clear-clock-flag`, { note: 'cleared from dashboard' }); toast.success(`Flag cleared for ${d.trk_id}`); load(); } catch (e) { toast.error(e.message); } };
  if (!rows || rows.length === 0) return null;
  return (
    <div className="rounded-lg border bg-white p-5 mb-6" style={{ borderColor: '#E5E3DC' }} data-testid="clock-drift-card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-bold flex items-center gap-2" style={{ color: '#1B1D1C' }}><Clock size={18} style={{ color: '#B42318' }} /> Device clock drift
          <span className="px-2 py-0.5 rounded-full text-xs" style={{ background: '#FBEBEB', color: '#8C2B2B' }}>{rows.length} flagged</span></h2>
        <a href="/admin/qr-exceptions" className="text-xs underline" style={{ color: '#0B6B55' }} data-testid="clock-drift-report-link">Full report</a>
      </div>
      <table className="w-full text-sm"><tbody>{rows.map(d => (
        <tr key={d.device_id} className="border-t" style={{ borderColor: '#F3F1EA' }} data-testid={`clock-drift-row-${d.trk_id}`}>
          <td className="py-2 font-mono">{d.trk_id} <span className="text-xs font-sans" style={{ color: '#9a9e96' }}>{d.device_type}</span></td>
          <td className="py-2">{d.tenant_name || '—'}</td>
          <td className="py-2 font-mono" style={{ color: '#B42318' }}>{d.drift_seconds > 0 ? '+' : ''}{d.drift_seconds}s</td>
          <td className="py-2 text-xs" style={{ color: '#6b7069' }}>{fmtDate(d.checked_at)} · {d.legs} legs</td>
          <td className="py-2 text-right"><div className="flex gap-1 justify-end">
            <Button data-testid={`clock-drift-recompute-${d.trk_id}`} size="sm" variant="outline" className="h-7 gap-1 border-[#D9D6CD]" onClick={() => recompute(d)}><RefreshCw size={12} /> Recompute legs</Button>
            <Button data-testid={`clock-drift-clear-${d.trk_id}`} size="sm" variant="outline" className="h-7 border-[#D9D6CD]" onClick={() => clear(d)}>Clear flag</Button>
          </div></td>
        </tr>))}</tbody></table>
    </div>
  );
}
